var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarIconinline = function SvgDollarIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 19 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    d: "M9.119 29.611a9.24 9.24 0 0 1-6.08-2.116c-1.686-1.404-2.775-3.36-3.056-5.49l1.454-.154a7.24 7.24 0 0 0 2.584 4.6 7.76 7.76 0 0 0 5.113 1.76c5.232 0 8.481-2.396 8.481-6.24 0-4.14-5.705-5.345-7.45-5.604-6.14-.952-8.72-3.032-8.72-6.954 0-4.294 4.011-6.542 7.994-6.542 4.63 0 7.602 2.136 8.837 6.352l-1.395.379c-1.054-3.586-3.489-5.33-7.442-5.33-2.253 0-6.541 1.078-6.541 5.14 0 2.641 1.279 4.602 7.53 5.568 5.435.841 8.677 3.46 8.677 7.004-.036 4.623-3.932 7.627-9.986 7.627"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    d: "M9.86 0H8.406v12.999H9.86zM9.86 17.594H8.406V32H9.86z"
  })));
};
export default SvgDollarIconinline;